import React, { Component } from 'react';

class AboutUs extends Component{
    render(){
        const { themeLayoutId, mainBanner } = this.props;
        return(
            <React.Fragment>

                {/* Beauty Theme */}

                {themeLayoutId === 'L03' &&
                    <section className="beauty-about">
                        <div className="container">
                        <div className="row">
                            <div className="col-xl-5 col-lg-6 col-md-12 offset-xl-1 text-center">
                            <img src={ mainBanner[2].Image.APC_ELEMENT_CONTENT } className="img-fluid" alt=""/>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-12">
                            <div className="about-section">
                                <div>
                                <h2>{ mainBanner[2].Title.APC_ELEMENT_CONTENT }</h2>
                                <div className="about-text">
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.sit voluptatem accusantium doloremque laudantium,totam rem aperiam.</p>
                                </div>
                                <div className="service small-section pb-0">
                                    <div className="row">
            
                                    <div className="col-sm-4 service-block1">
                                        <div>
                                        test
                                        </div>
                                        <h5>free shipping</h5>
                                    </div>
            
                                    <div className="col-sm-4 service-block1">
                                        <div>
                                        test
                                        </div>
                                        <h5>24 X 7 service</h5>
                                    </div>
            
                                    <div className="col-sm-4 service-block1">
                                        <div>
                                        test
                                        </div>
                                        <h5>festival offer</h5>
                                    </div>
            
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </section>
                }

                {/* end Beauty Theme */}

            </React.Fragment>
        )
    }
}

export default AboutUs